var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "40",
          height: "40",
          fill: "none"
        }
      },
      _vm.$listeners
    ),
    [
      _c("path", {
        attrs: {
          fill: "#eb3c00",
          "fill-rule": "evenodd",
          d:
            "M9.756 0h20.493c3.398 0 4.633.357 5.872 1.019a6.89 6.89 0 0 1 2.859 2.882C39.647 5.145 40 6.374 40 9.77v20.484c0 3.396-.353 4.63-1.02 5.874a6.95 6.95 0 0 1-2.859 2.858c-1.239.662-2.474 1.015-5.872 1.015H9.756c-3.398 0-4.632-.352-5.876-1.015a6.96 6.96 0 0 1-2.86-2.858C.353 34.884 0 33.65 0 30.254V9.77c0-3.396.353-4.625 1.02-5.869a6.91 6.91 0 0 1 2.86-2.882C5.133.357 6.358 0 9.756 0z"
        }
      }),
      _c("path", {
        attrs: {
          fill: "#fff",
          d:
            "M10 27.437V12.788L22.958 8 30 10.253v19.72l-7.042 2.123L10 27.437l12.958 1.56V11.944l-8.451 1.972v11.55L10 27.437z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }